import { post } from './request'

/**
 * 免费咨询 / 商务洽谈留资
 * POST /api/v1/lead-inquiries
 */
export function createLeadInquiry(payload) {
  return post('/lead-inquiries', payload)
}
